import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navigation from '../Navigation/Navigation';
import Footer from '../Footer/Footer';
import LoadingOverlay from '../Loading/LoadingOverlay';

export default function PublicLayout({ immersive = false }) {
  const userState = useSelector((state) => state.user);
  const featureState = useSelector((state) => state.feature);

  // Public navigation and routes depend on both auth and feature flags.
  if (
    !userState.bootstrapped ||
    userState.loading ||
    !featureState.bootstrapped ||
    featureState.loading
  ) {
    return <LoadingOverlay />;
  }

  return (
    <>
      {!immersive && <Navigation />}
      <div className="dashboard-root">
        <Outlet />
      </div>
      {!immersive && <Footer />}
    </>
  );
}
